// @ts-check
/* Add links */
$(document).ready(function () {
    var addLinks = $('.add-links');
    var listContents = [];
    var removeText = "Remove from shortcuts";
    var addText = "Add to shortcuts";
    var animationDelay = 250;
   
    listContents = JSON.parse(localStorage.getItem('wlist'));
   
    if (addLinks.length > 0) {
        addLinks.each(function (i) {
            var addLink = addLinks[i];
            /* 
            ON DOCUMENT READY:
            Check if the current link is in the local storage array:
            - if so give it the .added class and change the text
            */
            var currentLinkID = $(addLink).find('.wlist').data('localid');
            if($(listContents).length > 0){
                $(listContents).each(function(j){
                    if(listContents[j]["localId"] === currentLinkID){
                        $(addLink).find('.wlist')
                        .removeClass('loading')
                        .addClass('added')
                        .html(removeText);
                    }
                });          
            }       
            /*
                ON CLICK:
                When someone clicks on a link
            */
            $(addLink).on('click', 'a.wlist', function (e) {
                e.preventDefault();
                var wlistLocal = localStorage.getItem('wlist');
                var self = $(this);
                var localId = self.data('localid');
                var localTitle = self.data('title');         
               
                /*
                REMOVE FROM LIST AND LOCAL STORAGE (If the link is in the list allready)
                */
                if(self.hasClass('added')){
                    self.removeClass('added').addClass('loading');
                                  
                    if(wlistLocal !== null){
                        listContents = JSON.parse(localStorage.getItem('wlist'));
                        listContents = listContents.filter(function(el) {
                            return el.localId !== localId;
                        });
                        localStorage.setItem("wlist",JSON.stringify(listContents));
                    }
                    removeFromFavList(localId);

                    setTimeout(function(){
                        $(self)
                        .removeClass('loading')
                        .removeClass('pin')
                        .html(addText);
                    }, animationDelay);
                }
                /* ADD TO LIST AND LOCAL STORAGE */
                else{
                    if(wlistLocal !== null){
                        // get list from local storage   
                        listContents = JSON.parse(localStorage.getItem('wlist'));                 
                        // Check if list is shorter than 5 items
                        if(listContents.length < 5){
                            self.addClass('loading');
                            listContents.push({localId:localId, localTitle:localTitle});

                            localStorage.setItem("wlist",JSON.stringify(listContents));
                        } else{
                            alert("You can only add 5 items to your list");
                            return;
                        }

                    } else {
                        listContents = [];
                        listContents.push({localId:localId, localTitle:localTitle});
                        localStorage.setItem("wlist",JSON.stringify(listContents));
                    }

                    addToFavList(localId, localTitle);

                    setTimeout(function(){
                        $(self)
                        .removeClass('loading')
                        .addClass('added')
                        .html(removeText);
                    }, animationDelay);
                }
            }) // click

        })
    }

    /* If we are on a page that has the favourite list - Add or remove link from list*/
    function removeFromFavList(listItem){
        if($('.favourite-list').length > 0){
            $(".favourite-list")
            .find(".favourite-list-item[data-localid='" + listItem + "']")
            .animate({
                opacity: 0,
                padding: 0,
                height: 0
            }, 350, function () {
                $(this).remove();
            });  

        }
    }

    function addToFavList(listItem, title){
        if($('.favourite-list').length > 0){ 
            // Remove the no favourites list item
            $(".favourite-list .no-favourites").remove();
            $(".favourite-list")
            .append(
                '<li class="favourite-list-item" data-localid="'+listItem+'">' +
                '<a href="'+ listItem+'">' +
                '<span class="icon"></span>' +
                '<span class="remove">Remove</span>' +
                title +
                '</a>'+
                '</li>'
            );

        }
    }
});